'use client'
import { useState } from 'react'
import NewsletterSection from '@/components/NewsletterSection'

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' })
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setStatus('loading')
    try {
      const base = process.env.NEXT_PUBLIC_API_URL || 'http://127.0.0.1:8000/api/'
      const res = await fetch(`${base}contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ name: form.name, email: form.email, subject: form.subject, message: form.message }),
      })
      const json = await res.json()
      setStatus(json.key === 'success' ? 'success' : 'error')
      if (json.key === 'success') setForm({ name: '', email: '', subject: '', message: '' })
    } catch {
      setStatus('error')
    }
    setTimeout(() => setStatus('idle'), 5000)
  }

  const inputStyle: React.CSSProperties = { width: '100%', padding: '11px 14px', borderRadius: '4px', fontSize: '13px', background: 'rgba(220,228,240,0.92)', border: 'none', color: '#333', outline: 'none' }
  const labelStyle: React.CSSProperties = { fontSize: '13px', color: '#fff', fontWeight: 500, marginBottom: '6px', display: 'block' }

  return (
    <>
      {/* HERO */}
      <section className="relative overflow-hidden" style={{ height: '280px', background: '#07090e' }}>
        <div style={{ position: 'absolute', left: '-20px', top: 0, bottom: 0, width: '45%', zIndex: 1 }}>
          <img src="/ghassan-artistic.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.5 }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(90deg, rgba(7,9,14,0.7) 0%, transparent 70%)' }} />
        </div>
        <div style={{ position: 'absolute', right: 0, top: 0, bottom: 0, width: '42%', zIndex: 1 }}>
          <img src="/ghassan-real.jpg" alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.45 }} />
          <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(270deg, rgba(7,9,14,0.7) 0%, transparent 70%)' }} />
        </div>
        <div style={{ position: 'absolute', left: '10px', bottom: '-10px', fontSize: '200px', fontWeight: 900, color: 'transparent', WebkitTextStroke: '1.5px rgba(255,255,255,0.07)', lineHeight: 1, zIndex: 2, userSelect: 'none' }}>Ch</div>
        <div style={{ position: 'absolute', right: '16px', top: '10px', fontSize: '140px', fontWeight: 900, color: 'transparent', WebkitTextStroke: '1.5px rgba(255,255,255,0.06)', lineHeight: 1, zIndex: 2, userSelect: 'none' }}>R</div>
        <div style={{ position: 'absolute', inset: 0, zIndex: 3, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <h1 style={{ fontSize: '40px', fontWeight: 900, color: '#fff', letterSpacing: '0.14em' }}>CONTACT INFO</h1>
        </div>
        <div style={{ position: 'absolute', bottom: '20px', right: '20px', zIndex: 10, width: '48px', height: '48px', borderRadius: '50%', background: '#f97316', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
        </div>
      </section>

      {/* FORM — deep blue */}
      <section style={{ background: '#0e2060', padding: '60px 0' }}>
        <div style={{ maxWidth: '560px', margin: '0 auto', padding: '0 32px' }}>
          <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#fff', textAlign: 'center', marginBottom: '36px' }}>Get In Touch</h2>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={labelStyle}>Full Name<span style={{ color: '#f97316' }}>*</span></label>
                <input style={inputStyle} type="text" placeholder="please enter your Full Name" value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} required />
              </div>
              <div>
                <label style={labelStyle}>Email<span style={{ color: '#f97316' }}>*</span></label>
                <input style={inputStyle} type="email" placeholder="please enter your Email" value={form.email} onChange={e => setForm(p => ({ ...p, email: e.target.value }))} required />
              </div>
            </div>
            <div style={{ marginBottom: '16px' }}>
              <label style={labelStyle}>Subject</label>
              <input style={inputStyle} type="text" placeholder="please enter your Subject" value={form.subject} onChange={e => setForm(p => ({ ...p, subject: e.target.value }))} />
            </div>
            <div style={{ marginBottom: '24px' }}>
              <label style={labelStyle}>Message<span style={{ color: '#f97316' }}>*</span></label>
              <textarea style={{ ...inputStyle, resize: 'none', height: '120px' } as React.CSSProperties} placeholder="please enter your Message" value={form.message} onChange={e => setForm(p => ({ ...p, message: e.target.value }))} required />
            </div>
            <div style={{ textAlign: 'center' }}>
              <button type="submit" disabled={status === 'loading'}
                style={{ padding: '11px 40px', borderRadius: '4px', background: '#f97316', color: '#fff', fontSize: '14px', fontWeight: 700, border: 'none', cursor: status === 'loading' ? 'not-allowed' : 'pointer', opacity: status === 'loading' ? 0.75 : 1 }}>
                {status === 'loading' ? 'Sending...' : 'Send Email'}
              </button>
            </div>
            {status === 'success' && <p style={{ color: '#4ade80', textAlign: 'center', marginTop: '12px', fontSize: '13px' }}>✓ Message sent successfully!</p>}
            {status === 'error' && <p style={{ color: '#f87171', textAlign: 'center', marginTop: '12px', fontSize: '13px' }}>Something went wrong. Please try again.</p>}
          </form>
        </div>
      </section>

      {/* CONTACT INFO */}
      <section style={{ background: '#05070c', padding: '60px 0' }}>
        <div style={{ maxWidth: '560px', margin: '0 auto', padding: '0 32px', textAlign: 'center' }}>
          <h2 style={{ fontSize: '22px', fontWeight: 700, color: '#fff', marginBottom: '20px' }}>Contact Info</h2>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.65)" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
            <span style={{ fontSize: '14px', color: 'rgba(255,255,255,0.65)' }}>UAE – DUBAI – Alnoor Str</span>
          </div>
        </div>
      </section>

      <NewsletterSection />
    </>
  )
}
